import React from "react"
import { MdClose } from "react-icons/md"
import { FaMinus, FaPlus } from "react-icons/fa"

import { IconButton, } from "components"
import classes from "./BuyXFreeXModalCardButtons.module.scss"

const BuyXFreeXModalCardButtons = props => {
  const {
    reachedMaxQty,
    disabled,
    quantity,
    comboItemFoodDetail,
    setSelectedComboItems
  } = props

  const handleDecrease = () => {
    setSelectedComboItems(prev =>
      quantity === 1 ?
        prev.filter(selectedComboItem =>
          selectedComboItem.optionId !== comboItemFoodDetail.optionId
        )
        :
        prev.map(selectedComboItem =>
          selectedComboItem.optionId === comboItemFoodDetail.optionId
            ?
            {
              ...selectedComboItem,
              quantity: selectedComboItem.quantity - 1
            }
            :
            selectedComboItem
        )
    )
  }

  const handleIncrease = () => {
    if (reachedMaxQty) return

    setSelectedComboItems(prev =>
      !!quantity
        ?
        prev.map(selectedComboItem =>
          selectedComboItem.optionId === comboItemFoodDetail.optionId
            ?
            {
              ...selectedComboItem,
              quantity: selectedComboItem.quantity + 1
            }
            :
            selectedComboItem
        )
        :
        [...prev, {
          ...comboItemFoodDetail,
          quantity: 1
        }]

    )
  }

  return (
    <div className={classes["row"]}>
      {
        quantity > 0 &&
        <div className={classes["quantity"]}>
          {quantity}x
        </div>
      }
      {
        quantity > 0 &&
        <IconButton
          disabled={disabled}
          icon={quantity === 1 ? MdClose : FaMinus}
          color="white"
          onClick={handleDecrease}
          className={classes["button"]}
          size={13}
        />
      }
      <IconButton
        disabled={disabled}
        icon={FaPlus}
        color="white"
        onClick={handleIncrease}
        className={classes["button"]}
        size={13}
      />
    </div>
  )
}

export default BuyXFreeXModalCardButtons